import React from 'react'
import Translate from "../../../modules/local/Translate";
import {FaApple} from "react-icons/fa6";


export default function AppleLoginBtn({
                                          onSuccess, label = 'Sign in with Apple'
                                      }) {
    // if (!isIOS()) {
    //     return null;
    // }
    const responseAppleViaMob = () => {
        console.error('onclicked!');
        if (window.cordova && window.cordova.plugins && window.cordova.plugins.SignInWithApple) {
            window.cordova.plugins.SignInWithApple.signin(
                {requestedScopes: [0, 1]},
                function (response) {
                    console.error(response)
                    if (response['identityToken']) {
                        let fullname = '';

                        if (typeof response.fullName === 'string') {
                            // Đã là chuỗi, giữ nguyên
                            fullname = response.fullName;
                        } else if (typeof response.fullName === 'object' && response.fullName !== null) {
                            // Là object, ghép lại chuỗi
                            const { givenName = '', familyName = '' } = response.fullName;
                            fullname = [givenName, familyName].filter(Boolean).join(' ');
                        }

                        onSuccess({
                            ...response,
                            fullname: fullname || 'Apple User',
                            token: response.identityToken,
                            provider: 'apple'
                        })
                    }
                },
                function (err) {
                    console.error(err)
                    console.log(JSON.stringify(err))
                }
            )
        } else {
            console.error('Plugin not available.');
            console.error(window.cordova);
            console.error('Plugin not available..');
            console.error(window.cordova.plugins);
            alert('Plugin not available.')
        }
    }

    return (
        <Translate>
            {(t) => (
                <button
                    onClick={responseAppleViaMob}
                    className="
                flex items-center justify-center
                bg-white text-color-000
                border border-gray-300
                rounded-lg cursor-pointer
                hover:shadow-md transition-shadow duration-200
                py-3 px-6 gap-3
                w-full
            "
                    style={{
                        minHeight: '44px', // Chiều cao tối thiểu theo hướng dẫn của Apple
                        fontSize: '15px', // Kích thước chữ chuẩn của Apple
                        fontWeight: '500', // Semibold theo Apple (Tailwind's font-semibold is 600)
                        fontFamily: 'SF Pro Text, SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif', // Font chữ ưu tiên của Apple
                        letterSpacing: '0.03em', // Khoảng cách chữ nhẹ
                    }}
                >
                    <FaApple size={17} />

                    <span className="leading-none">
                 {t(label)}
            </span>
                </button>
            )}
        </Translate>
    )

}